<template>

  <div class="container" v-async.opacity="loading">
    <div class="row">
      <div class="col-xs-12">
        <h3 class="title">
          Plano Caminhos do Paraná
        </h3>
        <hr class="h-rule-yellow">
        <hr class="h-rule-side-yellow">
        <p>Para aderir a esse plano é necessário estar na lista de isentos da Caminhos do Paraná, por isso digite seu CPF ou CNPJ para podermos continuar:</p>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12">
        <div class="row border-row row-fix">
          <div class="col-md-7">
            <div class="content-box-small mg-form-fix">

              <form action="index.html" @submit.prevent="getLead" class="margin-50">
                <div class="alert alert-danger mg-fix" role="alert" v-if="errorMessage">
                  <strong>Atenção!</strong> {{errorMessage}}
               </div>
                <div class="form-group" :class="{'has-error':errors.has('taxIdNumber')}">
                  <label>CPF ou CNPJ:</label>
                  <input class="form-control small" type="text" pattern="^([A-Za-z0-9]{2}\.[A-Za-z0-9]{3}\.[A-Za-z0-9]{3}\/[A-Za-z0-9]{4}-[0-9]{2}|[A-Za-z0-9]{12}[0-9]{2}|[0-9]{3}\.[0-9]{3}\.[0-9]{3}-[0-9]{2}|[0-9]{11})$" name="taxIdNumber" v-model.lazy="taxIdNumber" v-validate="'required|cpfCnpj|accountExists:cpf'"
                    data-vv-validate-on="blur" v-mask-cpf-cnpj placeholder="" maxlength="18">
                  <div class="help-block">{{ errors.first('taxIdNumber') }}</div>
                </div>
                <div class="text-center">
                  <button id="btn-login" class="btn btn-lg btn-primary mg-top-8 " type="submit" name="button">
                    Avançar
                  </button>
                  <i class="icon-circle-right align-icon"></i>
                </div>
                <div class="text-center" v-if="isShow == 'SHOW'">
                  <div v-if="typePerson == 'PERSON'">
                     <router-link :to="{'name': 'adhesion', 'query':{'planId': '35'}}" class="btn btn-primary" tag="button">
                                MANUAL PF
                    </router-link>
                     <router-link :to="{'name': 'adhesion', 'query':{'planId': '36'}}" class="btn btn-primary" tag="button">
                                Automático PF
                    </router-link>
                  </div>
                   <div v-else>
                     <router-link :to="{'name': 'adhesion', 'query':{'planId': '37'}}" class="btn btn-primary" tag="button">
                                MANUAL PJ
                    </router-link>
                     <router-link :to="{'name': 'adhesion', 'query':{'planId': '38'}}" class="btn btn-primary" tag="button">
                                Automático PJ
                    </router-link>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div class="col-md-5">
            <div class="parana-way">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row margin-t30">
      <div class="col-xs-12">
        <router-link to="/inicio" class="btn btn-back">
          <i class="icon-circle-left align-icon-left"></i>
          Voltar
        </router-link>
      </div>
    </div>
  </div>
</template>
<style scoped lang="scss">
  .mg-form-fix {
    margin-top: 75px;
  }
  .content-box-small {
    width: 70%;
  }
  .mg-fix {
    margin-top: -20px;
    margin-bottom: 20px;
  }
  .mg-top-8 {
    margin-top: 8px;
  }
  @media (min-width: 651px) and (max-width: 991px) {
    .mg-form-fix {
      margin-top: -30px;
    }
  }
  @media screen and (max-width: 650px) {
    .mg-form-fix {
      margin-top: 0;
      margin-bottom: 60px;
    }
    .border-row {
      padding: 0;
    }
    .content-box-small {
      width: 100%;
    }
    .margin-t80 {
      margin-top: -10px;
    }
    .parana-way {
      display: none;
    }
  }
</style>
<script>
  import Sales from '../../services/sales';
  import Account from '../../services/account';
  import constantes from '../common/constantes';
  import {
    router
  } from '../../routes';

  export default {
    data() {
      return {
        taxIdNumber: undefined,
        loading: undefined,
        isShow: false,
        typePerson: undefined,
        errorMessage: undefined
      }
    },
    methods: {
      getLead() {

        this.errorMessage = undefined;
        this.isShow = false;
        let _self = this;
        this.loading = this.$validator.validateAll().then(() => {

          let cpf_cnpj = this.taxIdNumber.replace(/[.\-\/]/g, '').toUpperCase();
          this.typePerson = cpf_cnpj.length <= 11 ? 'PERSON' : 'COMPANY';
          let request = { taxpayerIdNumber: cpf_cnpj };

          return Account.accountExists({taxIdNumber: cpf_cnpj}).then(valid => {
            if(!valid)
              return;
            return Sales.getLead(request).then(response => {
              if (response.lead && response.status.code == 0) { //&& response.lead.status == constantes.CAMINHOS_PARANA_CADASTRADO
                
                

                if(response.lead.campaign != 'CAMINHOSDOPARANA'){
                  this.errorMessage = 'CPF?CNPJ não cadastrado no caminhos do Paraná!';
                  return;
                }
              
                response.lead.typeTaxId = this.typePerson;
                sessionStorage.setItem('lead', JSON.stringify(response.lead));
                this.isShow = true;
                this.$router.push({name: 'adhesion'});

              } else {
                 this.errorMessage = 'CPF?CNPJ não cadastrado!';
                 return;
              }
            }).catch((error) => {
              
              this.errorMessage = error.data && `${_self.typePerson == 'PERSON' ? 'CPF' : 'CNPJ'} não cadastrado no caminhos do Paraná!` || error.response && error.response.data.status.message;

            });

          });


        });
      }
    }
  }

</script>



// WEBPACK FOOTER //
// parana-way.vue?bf63ebb6